import api from '@/api';

import { PageResult } from '@/core/request/PageResult';
import { PageRequest } from '@/core/request/PageRequest';

import {
  Insurer,
  CreateInsurerRequest,
  UpdateInsurerRequest,
} from './Insurers.types';

import { API_BASE_URL } from '..';

const CONTROLLER_URL = `${API_BASE_URL}/insurers`;

export async function listInsurers(
  params?: PageRequest,
): Promise<PageResult<Insurer>> {
  const result = (await api.get(`${CONTROLLER_URL}`, params)) as unknown;

  return result as PageResult<Insurer>;
}

export async function getInsurer(id: number): Promise<Insurer> {
  const result = (await api.get(`${CONTROLLER_URL}/${id}`, null)) as unknown;

  return result as Insurer;
}

export async function createInsurer(
  obj: CreateInsurerRequest,
): Promise<Insurer> {
  const result = (await api.post(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as Insurer;
}

export async function updateInsurer(
  obj: UpdateInsurerRequest,
): Promise<Insurer> {
  const result = (await api.put(
    `${CONTROLLER_URL}/${obj.insurerId}`,
    obj,
    null,
  )) as unknown;

  return result as Insurer;
}

export async function deleteInsurer(id: number) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${id}`,
    {},
    null,
  )) as unknown;

  return result;
}

export async function activeInsurer(id: number) {
  const result = (await api.put(
    `${CONTROLLER_URL}/${id}/active`,
    {},
    null,
  )) as unknown;

  return result;
}

export async function inactiveInsurer(id: number) {
  const result = (await api.put(
    `${CONTROLLER_URL}/${id}/inactive`,
    {},
    null,
  )) as unknown;

  return result;
}
